import React from "react"
import PropTypes from "prop-types"
import { arrowLeft, arrowRight } from "./arrows"

export const title = "Buidling name"

export const occupancy = 50

function Occupancy(props) {

  /**
   * Arrow
   */
  const showArrow =
    props.showArrow === "left"
      ? arrowLeft
      : props.showArrow === "right"
        ? arrowRight
        : ""

  /**
   * Debug
   */
  const debuginfo = <div className="debuginfo">For debugging only:<br />{props.buildingNumbers} spaces<br />{props.realNumber} from api<br />{props.correctionNumber} after correction<br />{props.correctionFactor} factor</div>
  const showdebuginfo = props.debug ? debuginfo : ''

  const occupancyBackgroundColor = props.occupancy <= props.LEVEL_QUITE ? props.COLOR_QUITE : props.occupancy > props.LEVEL_BUSY ? props.COLOR_BUSY : props.COLOR_MODERATE

  return (
    <div className="occupancy-container" >

      <div className="building-name">
        <div className="title">{props.title}</div>
        {showArrow}
      </div>

      <div className="occupancy-bar">
        <div className="inner"
          style={{
            height: props.occupancy + '%',
            backgroundColor: occupancyBackgroundColor,
          }}
        ></div>
      </div>

      <div className="occupancy-status">{props.occupancy}%</div>



      {showdebuginfo}


      {/* <div className="colorBlindBox" style={{
        width: `100px`,
        height: `200px`,
        backgroundColor: `white`,
        margin: `0 auto`,
        position: `relative`,
        border: `5px solid black`,
        padding: `5px`
      }}>
        <div className="inner" style={{
          width: `calc(100px - 20px)`,
          height: occupancy + '%',
          // height: `50%`,
          minHeight: `5px`,
          backgroundColor: `black`,
          position: `absolute`,
          bottom: `5px`
        }}></div>
      </div> */}
    </div>
  )
}

Occupancy.propTypes = {
  title: PropTypes.string,
  occupancy: PropTypes.number
}

Occupancy.defaultProps = {
  title,
  occupancy
}

export default Occupancy
